
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { DetailedBotAccount } from '@/types/trader';
import { fetchDetailedBotAccounts } from '@/services/bot-account-service';

export const usePropBotAccounts = (botId: string) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['propBotAccounts', botId, user?.id],
    queryFn: () => {
      if (!user?.id) return [];
      // fetchDetailedBotAccounts already uses original_bot_id for filtering
      return fetchDetailedBotAccounts(botId, user.id);
    },
    enabled: !!botId && !!user?.id,
    staleTime: 0, // Always fetch fresh data
  });
};
